{
  "email": "Email address",
  "noEmailDelivery": "This installation sends no email. Ask an administrator to reset your password.",
  "requestLink": "Send reset link",
  "sent": "If an account uses this address, we have sent it a link.",
  "title": "Reset your password"
}
